import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useConfig } from "./config";
import { toast } from "react-hot-toast";
import "./Login.css";

function ApproveAccount() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { config } = useConfig();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [accountDetails, setAccountDetails] = useState(null);

  useEffect(() => {
    const approveAccount = async () => {
      if (!token) {
        setError("No approval token provided");
        setProcessing(false);
        return;
      }

      try {
        //console.log("Approving account with token:", token);
        const response = await fetch(
          `${config.API_BASE_URL}/api/auth/approve-account?token=${token}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          //console.log("Approval response:", data);
          setSuccess(true);
          setAccountDetails(data);
          toast.success("Account created successfully!");
        } else {
          const data = await response.json();
          setError(data.detail || "Account approval failed");
          toast.error("Account approval failed. Please try again.");
        }
      } catch (error) {
        //console.error("Approval error:", error);
        setError("An error occurred during account approval");
        toast.error("Account approval failed. Please try again.");
      } finally {
        setProcessing(false);
      }
    };

    if (token) {
      approveAccount();
    }
  }, [token, config, navigate]);

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Account Approval</h2>

        {processing ? (
          <div className="verification-status">
            <div className="verification-loading"></div>
            <p>Processing account approval...</p>
          </div>
        ) : success ? (
          <div className="verification-success">
            <p>Account created successfully!</p>
            <p>
              An account has been created for{" "}
              <strong>{accountDetails?.email}</strong> with role{" "}
              <strong>{accountDetails?.role}</strong>.
            </p>
            <button
              className="login-button"
              onClick={() => navigate("/login", { replace: true })}
            >
              Go to Login
            </button>
          </div>
        ) : error ? (
          <div className="verification-error">
            <p>Error: {error}</p>
            <p>The approval link may have expired or is invalid.</p>
            <button
              className="login-button"
              onClick={() => navigate("/login", { replace: true })}
            >
              Back to Login
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default ApproveAccount;
